// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"30d84f356060aa3c03b2","966":"c86427e774d92ee9b2b1"}[chunkId] + ".js";
};